<template>
    <div id="loading">
        <v-progress-circular
            :size="80"
            color="primary"
            indeterminate
        ></v-progress-circular>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
#loading {
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    background-color: #23232347;
    z-index: 250;
    position: absolute;
    height: 100%;
}
</style>
